import React from 'react';
//import compose from 'recompose/compose';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { stringify } from 'query-string';
import physical from '../physical';
import IsPhysicalDue from './PhysicalDue'

const styles = {
    iconRed: { 
           paddingRight: '0.5em' ,
           color: 'orange'
        },
    icon: { 
        paddingRight: '0.5em' ,
        },
    link: {
        display: 'inline-flex',
        alignItems: 'center'
    },
};

const LinkToPhysical = ({ classes, record}) => {

    return <Button
        size="small"
        color= "primary" 
        component={Link}
        to={{
            pathname: '/physicals',
            search: stringify({
                page: 1,
                perPage: 25,
                sort: 'id',
                order: 'DESC',
                filter: JSON.stringify({ ssn: record.ssn }),
            }),
        }}
        className={classes.link}
    >
        <physical.icon className={ (IsPhysicalDue(record) && IsPhysicalDue(record).id ===1)?  classes.iconRed: classes.icon}/>Physical
    </Button>
};

/*const enhance = compose(
    withStyles(styles),
    
);*/

export default withStyles(styles)(LinkToPhysical);
